import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjCancellationOfOrder"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.78198 1.875C5.50584 1.875 5.28198 2.09886 5.28198 2.375V3.39097C5.28198 3.66711 5.50584 3.89097 5.78198 3.89097H8.81391C9.09006 3.89097 9.31391 3.66711 9.31391 3.39097V2.375C9.31391 2.09886 9.09006 1.875 8.81391 1.875H5.78198ZM4.27399 3.125H2.25C1.69772 3.125 1.25 3.57271 1.25 4.125V17.2447C1.25 17.797 1.69772 18.2447 2.25 18.2447H12.191C11.0067 17.3852 10.2365 15.9897 10.2365 14.4144C10.2365 12.3714 11.5317 10.631 13.3458 9.96949V4.125C13.3458 3.57272 12.8981 3.125 12.3458 3.125H10.3219V4.14695C10.3219 4.4231 10.098 4.64695 9.82188 4.64695H4.77399C4.49784 4.64695 4.27399 4.4231 4.27399 4.14695V3.125ZM3.51611 6.97693C3.37804 6.97693 3.26611 7.08886 3.26611 7.22693V7.98691C3.26611 8.12498 3.37804 8.23691 3.51611 8.23691H11.08C11.218 8.23691 11.33 8.12498 11.33 7.98691V7.22693C11.33 7.08886 11.218 6.97693 11.08 6.97693H3.51611ZM3.26611 9.99884C3.26611 9.86077 3.37804 9.74884 3.51611 9.74884H7.1721C7.31018 9.74884 7.4221 9.86077 7.4221 9.99884V10.7588C7.4221 10.8969 7.31018 11.0088 7.1721 11.0088H3.51611C3.37804 11.0088 3.26611 10.8969 3.26611 10.7588V9.99884ZM14.9659 17.9563C17.0557 17.9563 18.7498 16.2622 18.7498 14.1725C18.7498 12.0827 17.0557 10.3886 14.9659 10.3886C12.8762 10.3886 11.1821 12.0827 11.1821 14.1725C11.1821 16.2622 12.8762 17.9563 14.9659 17.9563ZM16.0305 12.4425L14.9805 13.4924L13.9305 12.4425L13.2306 13.1425L14.2805 14.1924L13.2305 15.2424L13.9305 15.9424L14.9805 14.8924L16.0305 15.9424L16.7305 15.2424L15.6805 14.1924L16.7304 13.1425L16.0305 12.4425Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var SJ_cancellation_of_order = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_cancellation_of_order as default };
